export const ROLE_RANK = {
  subaccount_user: 1, subaccount_admin: 2, manager: 3, manager_billing: 4, agency_admin: 5, agency_owner: 6,
};

export const ROLE_LABELS = {
  agency_owner: "Owner", agency_admin: "Admin", manager_billing: "Manager + billing",
  manager: "Manager", subaccount_admin: "Staff", subaccount_user: "Staff (basic)",
};

export const ROLES = [
  { value: "subaccount_user", label: "Staff (basic) — see everything, change nothing" },
  { value: "subaccount_admin", label: "Staff — view & edit their clients" },
  { value: "manager", label: "Manager — their clients, staff & settings (no billing)" },
  { value: "manager_billing", label: "Manager + billing — all of the above plus billing" },
  { value: "agency_admin", label: "Admin — full access to everything" },
];

const rank = (role) => ROLE_RANK[role] || 0;
export const isAgencyRole = (role) => rank(role) >= 5;
export const isManagerRole = (role) => rank(role) >= 3;
export const canBill = (role) => rank(role) >= 4 && role !== "manager";
export const isReadOnly = (role) => role === "subaccount_user";
export const assignableRoles = (role) => ROLES.filter((r) => isAgencyRole(role) || rank(r.value) <= rank(role));
export const canManage = (actor, target) => target.role !== "agency_owner" && (isAgencyRole(actor.role) || rank(target.role) <= rank(actor.role));
